module.exports = require("lodash/capitalize");